import { Button, Icon, Input, message, Steps, Spin } from 'antd';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { alertSuccess, alertError } from './../../../services/dialog';
import { forgotPassword } from './../../../utils/forgotPassword';
import './styles.css';
import lang from './../../../languages/en';
import { validateEmail } from './../../../services/ruleValidate'
import { titleHead } from './../../../services/helper'
import history from './../../../services/history'

const Step = Steps.Step;

class ForgotPassword extends Component {
    constructor(props) {
        super(props)

        this.state = {
            inputs: {
                email: '',
            },
            loading_sendmail: false,
            message: ''
        }
    }

    componentDidMount() {
        titleHead("Forgot Password")
    }

    checkFieldEmpty = (value, column) => {
        if (!value) {
            this.setState({
                message: lang.email_address_null
            })
        }
    }

    validate = () => {
        if (!validateEmail(this.state.inputs.email)) {
            this.setState({
                message: lang.email_invalid
            })
            return false;
        }
        return true;
    }

    handleVerifyEmail = e => {
        e.preventDefault()
        if (!this.validate()) return;

        this.setState({
            loading_sendmail: true,
        })
        let data = {
            email: this.state.inputs.email,
        }

        forgotPassword(data).then(res => {
            alertSuccess(`${lang.password_reset_email_sent} ${this.state.inputs.email} ${lang.password_reset_email_sent_line2}`, null, () => history.push('/login'))
            this.setState({
                loading_sendmail: false,
            })
        }).catch(err => {
            alertError(`${lang.something_went_wrong}`, null, () => history.push('/login'))
            this.setState({
                loading_sendmail: false,
            })
        })
    }

    onChange = (value, column) => {
        this.checkFieldEmpty(value, column)
        this.setState({
            inputs: {
                ...this.state.inputs,
                [column]: value,
            },
        })
    }

    checkButtonSubmit = () => {
        const { email } = this.state.inputs
        if (!email) return true
        return false;
    }

    render() {
        return (
            <div id="reset-password">
                <div className="reset-password-form">
                    <Spin spinning={this.state.loading_sendmail} tip='Send Mail'>
                        <div className="reset-pass-input">
                            <h1>{lang.title_reset_password}</h1>
                            <p>{lang.enter_account_email_and_click_send}<br>
                            </br>{lang.enter_account_email_and_click_send_line2}</p>
                            <form
                                onSubmit={this.handleVerifyEmail}
                                autoComplete="off"
                            >
                                <div className='input'>
                                    <Input
                                        prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        placeholder="Username"
                                        onChange={e => this.onChange(e.target.value, 'email')}
                                        autoComplete="off"
                                        maxLength={32}
                                    />
                                    <span className='message'>{this.state.message}</span>
                                </div>
                                <div>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        loading={this.state.loading_sendmail}
                                        className="reset-password-form-button"
                                        disabled={this.checkButtonSubmit()}
                                    >Send Email</Button>
                                    <div className="do-not-email">
                                        <h3>{lang.not_receive_email}</h3>
                                        <ul>
                                            <li>{lang.check_junk_mail}</li>
                                            <li>{lang.warning_send_email}</li>
                                            <li>
                                                <a className="location" href="https://www.yamatoamerica.com/locations/" target='_black'>Contact Yamato.</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </form>
                            <br></br>
                            <br></br>
                            <Link to="/login">Return to Login</Link>
                        </div>
                        <div className="reset-flow">
                            <h2>{lang.reset_password_flow}</h2>
                            <h3>{lang.follow_theses_step}</h3>
                            <Steps direction="vertical" current={0} className='step-reset-password'>
                                <Step title="In Progress" description={lang.reset_password_step1} />
                                <Step title="Waiting" description={lang.reset_password_step2} />
                                <Step title="Waiting" description={lang.reset_password_step3} />
                            </Steps>
                        </div>
                    </Spin>
                </div>
            </div>
        )
    }
}

export default ForgotPassword


// WEBPACK FOOTER //
// ./src/containers/auth/forgot-password/index.js